import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["data-qa"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_indicator_dot = _resolveComponent("base-indicator-dot")
  const _component_tooltip = _resolveComponent("tooltip")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass($options.classList)
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.mappedStatuses, (status) => {
      return (_openBlock(), _createElementBlock("div", {
        key: status.statusName,
        class: "_flex _ai-c _gap-1 _tc--base",
        "data-qa": status.dataQa
      }, [
        _createVNode(_component_base_indicator_dot, {
          color: status.colorCode
        }, null, 8 /* PROPS */, ["color"]),
        _createTextVNode(" " + _toDisplayString(status.statusName) + " ", 1 /* TEXT */),
        (status.tooltipText)
          ? (_openBlock(), _createBlock(_component_tooltip, {
              key: 0,
              text: status.tooltipText,
              "icon-name": "circle-info"
            }, null, 8 /* PROPS */, ["text"]))
          : _createCommentVNode("v-if", true)
      ], 8 /* PROPS */, _hoisted_1))
    }), 128 /* KEYED_FRAGMENT */))
  ], 2 /* CLASS */))
}